<template>
  <div
    class="month-select"
    :class="{
      'is-invalid': invalid,
      'active-label': container || selectedValue,
    }"
  >
    <div
      class="overlay"
      :class="{
        active: container,
      }"
      @click="closeContainer"
    ></div>

    <div class="c-input">
      <div v-if="label" class="label">
        {{ label }}
        <!-- <div class="label__info">
            <c-button
              size="iconic"
              icon="info"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: label,
                placement: 'bottom'
              }"
            />
          </div> -->
      </div>
      <div v-if="floatingLabel" class="label label--hidden">
        {{ floatingLabel }}
        <!-- <div class="label__info">
            <c-button
              size="iconic"
              icon="info"
              v-b-popover.html="{
                container: '#app',
                trigger: 'hover',
                content: label,
                placement: 'bottom'
              }"
            />
          </div> -->
      </div>
      <div class="c-input-wrapper" @click="openContainer">
        <div class="icon">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.2222 3H2.77778C1.79594 3 1 3.69645 1 4.55556V15.4444C1 16.3036 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.2041 3 15.2222 3Z"
              stroke="#8E9CBB"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M13 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 1V5" stroke="#8E9CBB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <rect x="4" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="4" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="8" y="12" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="8" width="2" height="2" fill="#8E9CBB" />
            <rect x="12" y="12" width="2" height="2" fill="#8E9CBB" />
          </svg>
        </div>

        <div
          class="c-input-value"
          :class="{
            'c-input-value_placeholder': !selectedValue,
            'c-input-value_type_select_clearable': clearable,
          }"
          @click="openContainer"
        >
          <div class="c-input-value-single">
            {{ getLabel() || placeholder }}
          </div>
        </div>

        <div class="c-input-actions">
          <div
            v-if="clearable"
            class="c-input-action c-input-action_clear"
            :class="{
              'c-input-action_clear_active': selectedValue,
            }"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" @click="clear">
              <path
                d="M0.325608 10.746C-0.0649162 10.3555 -0.0649162 9.72233 0.325608 9.33181L9.36312 0.292893C9.75364 -0.0976313 10.3868 -0.0976309 10.7773 0.292893C11.1679 0.683418 11.1679 1.31658 10.7773 1.70711L1.73982 10.746C1.3493 11.1365 0.716132 11.1365 0.325608 10.746Z"
              />
              <path
                d="M10.6836 10.6835C11.0741 10.293 11.0741 9.65986 10.6836 9.26933L1.70711 0.292893C1.31658 -0.0976313 0.683417 -0.0976309 0.292893 0.292893C-0.0976311 0.683418 -0.0976311 1.31658 0.292893 1.70711L9.26935 10.6835C9.65987 11.0741 10.293 11.0741 10.6836 10.6835Z"
              />
            </svg>
          </div>
        </div>

        <div v-if="floatingLabel" class="floating-label">
          {{ floatingLabel }}
        </div>
      </div>

      <div
        class="c-input-border"
        :class="{
          active: container,
        }"
      ></div>

      <div
        class="c-input-container"
        :class="{
          active: container,
        }"
      >
        <div class="c-input-container-date">
          <div class="c-input-container__close" @click="closeContainer">
            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
                fill="#8E9CBB"
              />
              <path
                d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
                fill="#8E9CBB"
              />
            </svg>
          </div>

          <div class="c-input-container__toggler">
            <div
              class="toggler-item"
              :class="{
                active: activeBlock === 'from',
              }"
              @click="activeBlock = 'from'"
            >
              <span> Начало периода</span>
            </div>
            <div
              class="toggler-item"
              :class="{
                active: activeBlock === 'to',
              }"
              @click="activeBlock = 'to'"
            >
              <span>Конец периода</span>
            </div>
          </div>

          <div class="month-select__calendars">
            <div
              class="month-select__from"
              :class="{
                active: activeBlock === 'from',
              }"
            >
              <div class="month-select__year">
                <button type="button" class="month-select__prev" @click="prevFromYear">
                  <svg-icon name="chevron-left" :size="14"></svg-icon>
                </button>
                {{ from.year }}
                <button type="button" class="month-select__next" @click="nextFromYear">
                  <svg-icon name="chevron-right" :size="14"></svg-icon>
                </button>
              </div>
              <div class="month-select__months">
                <div
                  v-for="m in months"
                  :key="m.id"
                  class="month"
                  :class="{
                    active: from.year === from.selectedYear && m.id === from.selectedMonth,
                  }"
                  @click="selectFromMonth(m)"
                >
                  {{ m.name.slice(0, 3) }}
                </div>
              </div>
            </div>
            <div
              class="month-select__to"
              :class="{
                active: activeBlock === 'to',
              }"
            >
              <div class="month-select__year">
                <button type="button" class="month-select__prev" @click="prevToYear">
                  <svg-icon name="chevron-left" :size="14"></svg-icon>
                </button>
                {{ to.year }}
                <button type="button" class="month-select__next" @click="nextToYear">
                  <svg-icon name="chevron-right" :size="14"></svg-icon>
                </button>
              </div>
              <div class="month-select__months">
                <div
                  v-for="m in months"
                  :key="m.id"
                  class="month"
                  :class="{
                    active: to.year === to.selectedYear && m.id === to.selectedMonth,
                  }"
                  @click="selectToMonth(m)"
                >
                  {{ m.name.slice(0, 3) }}
                </div>
              </div>
            </div>
          </div>

          <error-feedback v-if="periodError" text="Указан некорректный период"></error-feedback>

          <div class="c-input-container__actions">
            <c-button
              class="c-input-container-period-action"
              size="small"
              label="Применить"
              :icon="{ icon: 'check', color: 'success' }"
              @click="apply"
            />

            <c-button
              class="c-input-container-period-action"
              size="small"
              label="Сбросить"
              :icon="{ icon: 'close', color: 'secondary' }"
              @click="reset"
            />
          </div>

          <div class="c-input-container__mobile-actions">
            <c-button class="c-input-container-period-action reset" label="Отменить" @click="reset" />

            <c-button class="c-input-container-period-action apply" color="primary" label="Сохранить" @click="apply" />
          </div>
        </div>
      </div>
    </div>

    <error-feedback v-if="error" :text="error"></error-feedback>
  </div>
</template>

<script>
import { ru } from "vuejs-datepicker/dist/locale";
import moment from "moment";

import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";
import SvgIcon from "@/components/svg-icon";

import { MONTHS } from "@/utils/date/months";

export default {
  name: "c-input",

  components: {
    CButton,
    ErrorFeedback,
    SvgIcon,
  },

  props: ["value", "label", "floatingLabel", "invalid", "error", "clearable", "placeholder"],

  data() {
    return {
      ru,

      from: {
        year: null,
        selectedYear: null,
        selectedMonth: null,
        currentYear: null,
        currentMonth: null,
      },

      to: {
        year: null,
        selectedYear: null,
        selectedMonth: null,
        currentYear: null,
        currentMonth: null,
      },

      container: false,
      months: MONTHS.map((m, i) => ({
        id: i + 1,
        name: m,
        value: `${i + 1}`.padStart(2, "0"),
      })),

      periodError: false,

      activeBlock: "from",
    };
  },

  computed: {
    fromMonthString() {
      if (!this.from.currentMonth) return "";
      return `${this.from.currentMonth}`.padStart(2, "0");
    },
    fromPeriodString() {
      if (!this.from.currentYear || !this.from.currentMonth) return "";
      return `${this.from.currentYear}-${this.fromMonthString}-01`;
    },
    toMonthString() {
      if (!this.to.selectedMonth) return "";
      return `${this.to.selectedMonth}`.padStart(2, "0");
    },
    toPeriodString() {
      if (!this.to.currentYear || !this.to.currentMonth) return "";
      return `${this.to.currentYear}-${this.toMonthString}-01`;
    },
    selectedValue() {
      if (this.fromPeriodString && this.toPeriodString)
        return {
          from: this.fromPeriodString,
          to: this.toPeriodString,
        };
      return null;
    },
  },

  watch: {
    selectedValue(value) {
      this.$emit("input", value);
    },

    value(value) {
      if (value) {
        if (this.selectedValue && this.selectedValue.from === value.from && this.selectedValue.to === value.to) return;
        this.setFromDate(value.from);
        this.setToDate(value.to);
        this.saveValues();
      } else {
        this.clearValues();
      }
    },
  },

  created() {
    this.from.year = moment().get("year");
    this.to.year = moment().get("year");
    if (this.value) {
      this.setFromDate(this.value.from);
      this.setToDate(this.value.to);

      this.saveValues();
    }
  },

  methods: {
    openContainer() {
      this.container = true;
    },

    closeContainer() {
      this.container = false;
      this.activeBlock = "from";
    },

    getFromLabel() {
      if (!this.from.currentMonth || !this.from.currentYear) return "";
      const month = this.months.find((m) => m.id === this.from.currentMonth);
      if (month) return `${month.name} ${this.from.currentYear}`;
      return "";
    },

    getToLabel() {
      if (!this.to.currentMonth || !this.to.currentYear) return "";
      const month = this.months.find((m) => m.id === this.to.currentMonth);
      if (month) return `${month.name} ${this.to.currentYear}`;
      return "";
    },

    getLabel() {
      const fromLabel = this.getFromLabel();
      const toLabel = this.getToLabel();
      if (!fromLabel && !toLabel) return "";
      return `${fromLabel} - ${toLabel}`;
    },

    prevFromYear() {
      this.from.year -= 1;
      this.periodError = false;
    },

    nextFromYear() {
      this.from.year += 1;
      this.periodError = false;
    },

    prevToYear() {
      this.to.year -= 1;
      this.periodError = false;
    },

    nextToYear() {
      this.to.year += 1;
      this.periodError = false;
    },

    setFromDate(date) {
      date = moment(date, "YYYY-MM-DD");
      if (date.isValid()) {
        this.from.selectedYear = date.get("year");
        this.from.year = this.from.selectedYear;
        this.from.selectedMonth = date.get("month") + 1;
      }
    },

    setToDate(date) {
      date = moment(date, "YYYY-MM-DD");
      if (date.isValid()) {
        this.to.selectedYear = date.get("year");
        this.to.year = this.to.selectedYear;
        this.to.selectedMonth = date.get("month") + 1;
      }
    },

    selectFromMonth(month) {
      this.from.selectedYear = this.from.year;
      this.from.selectedMonth = month.id;
      this.periodError = false;
    },

    selectToMonth(month) {
      this.to.selectedYear = this.to.year;
      this.to.selectedMonth = month.id;
      this.periodError = false;
    },

    saveValues() {
      this.from.currentYear = this.from.selectedYear;
      this.from.currentMonth = this.from.selectedMonth;

      this.to.currentYear = this.to.selectedYear;
      this.to.currentMonth = this.to.selectedMonth;
    },

    apply() {
      if (this.from.selectedYear || this.from.selectedMonth || this.to.selectedYear || this.to.selectedMonth) {
        if (!this.from.selectedMonth || !this.from.selectedYear || !this.to.selectedMonth || !this.to.selectedYear) {
          this.periodError = true;
          return;
        }
        const from = moment(`${this.from.selectedYear}-${this.from.selectedMonth}-01`, "YYYY-MM-DD");
        const to = moment(`${this.to.selectedYear}-${this.to.selectedMonth}-01`, "YYYY-MM-DD");

        if (!from.isValid || !to.isValid || from.isAfter(to)) {
          this.periodError = true;
          return;
        }
      }

      this.saveValues();

      this.closeContainer();
    },

    reset() {
      if (this.value) {
        this.setFromDate(this.value.from);
        this.setToDate(this.value.to);
        this.saveValues();
      } else {
        this.clearValues();
      }
      this.closeContainer();
    },

    clearValues() {
      this.from.year = moment().get("year");
      this.to.year = moment().get("year");

      this.from.selectedYear = null;
      this.from.selectedMonth = null;
      this.to.selectedYear = null;
      this.to.selectedMonth = null;

      this.saveValues();
    },

    clear() {
      this.clearValues();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.month-select {
  min-width: 168px;

  &__from {
    margin-right: 23px;
  }
  &__year {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
    border-bottom: 1px solid #dfe4ef;
    font-size: 15px;
    font-weight: 500;
    padding-bottom: 10px;

    button {
      background: transparent;
      border: none;
      box-shadow: none;
      padding: 0;
    }
  }
  &__calendars {
    display: flex;
  }
  &__months {
    margin: -2.5px -3.5px;
    display: flex;
    flex-wrap: wrap;
  }
  .month {
    width: 60px;
    height: 32px;
    border: 1px solid #d3d8df;
    border-radius: 50px;
    margin: 2.5px 3.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 15px;
    font-weight: 400;

    &:hover {
      border-color: $color-primary;
    }

    &.active {
      background-color: $color-primary;
      border-color: $color-primary;
      color: white;
    }
  }
  .overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 501;
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;

    &.active {
      visibility: visible;
      opacity: 1;

      @include onlyMobile {
        background: rgba(0, 0, 0, 0.7);
        transition: 0.3s;
      }
    }
  }

  .label {
    max-width: 100%;

    font: 400 12px Fira Sans;
    color: $color-label;
    transition: all 200ms;
    display: flex;
    align-items: center;

    line-height: 13px;
    margin-bottom: 10px;

    &__info {
      margin-left: 4px;
      display: inline-block;
    }

    &--hidden {
      opacity: 0;
      visibility: hidden;
    }
  }

  &.active-label {
    .floating-label {
      font-size: 12px;
      transform: translate3d(0, -100%, 0);
      pointer-events: all;
      width: 100%;
      white-space: normal;
    }
  }

  .floating-label {
    position: absolute;
    overflow: hidden;
    left: 0;
    width: calc(100% - 30px);
    white-space: nowrap;
    text-overflow: ellipsis;
    color: $color-label;
    font-size: 15px;
    line-height: 13px;
    transition: all 250ms;
    pointer-events: none;
    padding-bottom: 10px;
  }

  .icon {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    order: 5;
    margin-left: 10px;
    margin-right: 0;

    svg {
      margin-bottom: 5px;
    }
  }
}

.c-input {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;

  &-wrapper {
    width: 100%;
    display: flex;
    cursor: pointer;
  }

  &-actions {
    display: flex;
    order: 3;
    align-items: flex-start;
    margin-left: auto;
  }

  &-action {
    margin-left: 10px;
    width: 0;

    &_clear {
      margin-top: -3px;
      //transition: .2s;
      opacity: 0;
      visibility: hidden;
      cursor: pointer;

      svg {
        fill: $color-secondary;
      }

      &_active {
        width: auto;
        opacity: 1;
        visibility: visible;
      }
    }
  }

  &-value {
    width: 100%;
    height: 30px;
    font-size: 15px;
    padding: 0 0 13px 0;
    cursor: pointer;
    order: 2;
    cursor: pointer;
    height: auto;
    min-height: 30px;
    padding-bottom: 0;
    width: 100%;
    max-width: 100%;
    overflow: hidden;

    &-single {
      max-width: 100%;
      margin-top: -2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &_placeholder {
      color: $color-label;
    }
  }

  &-border {
    height: 1px;
    width: 100%;
    position: absolute;
    background: $color-control-border;
    bottom: 0;
    transition: 0.2s;

    &.active {
      background: $color-primary;
    }
  }

  &-container {
    position: absolute;
    background: #ffffff;
    box-shadow: $box-shadow-container;
    border-radius: $border-radius-container;
    z-index: 502;
    top: 50px;
    width: 594px;
    box-sizing: border-box;
    transition: 0.2s;
    opacity: 0;
    visibility: hidden;
    padding: 30px 24px;

    &__close {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 2;
    }

    &__toggler {
      display: none;
    }

    &.active {
      top: 100%;
      opacity: 1;
      visibility: visible;

      margin-top: 10px;
      left: 0;
    }

    &__actions {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }

    &__mobile-actions {
      display: none;
    }

    .c-input-container-period-action {
      margin-left: 8px;
    }

    @include onlyMobile {
      position: fixed;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      padding: 20px 15px 0px !important;
      transition: none;
      border-radius: 0;

      &__close {
        display: block;
      }

      &__toggler {
        display: flex;
        margin-top: 15px;
        padding-bottom: 12px;
        position: relative;
        margin-left: -15px;
        margin-right: -15px;
        margin-bottom: 25px;

        &:before {
          content: "";
          position: absolute;

          left: 0;
          right: 0;
          bottom: 0;
          height: 12px;

          background: linear-gradient(to top, #8e9cbb 0%, #ffffff 100%);
          opacity: 0.2;
        }

        .toggler-item {
          flex-grow: 1;
          flex-basis: 50px;
          display: flex;
          justify-content: center;

          font-weight: 500;
          font-size: 13px;

          color: $color-primary;

          &.active {
            color: #333333;
            span {
              position: relative;

              &:before {
                content: "";
                position: absolute;
                bottom: -16px;
                height: 4px;
                left: 0;
                right: 0;
                background: $color-secondary;
              }
            }
          }
        }
      }

      &__actions {
        display: none !important;
      }

      &__mobile-actions {
        display: flex;
        margin-left: -15px;
        margin-right: -15px;
        margin-top: 25px;

        .c-input-container-period-action {
          margin: 0;
          flex-grow: 1;
          flex-basis: 50%;
          border-radius: 0;
        }
      }

      .month-select__from {
        margin-right: 0;
        &:not(.active) {
          display: none;
        }
      }

      .month-select__to {
        &:not(.active) {
          display: none;
        }
      }

      .month-select__calendars {
        width: 270px;
        margin: auto;
      }

      &__actions {
        margin-left: -15px;
        margin-right: -15px;
        margin-top: 8px;
        display: flex;
      }
      &__action {
        width: 100%;
        height: 38px;
        border: none;
        background: transparent;
        outline: none;
        font-size: 15px;
        font-weight: 500;
      }
      &__apply {
        background: $color-primary;
        color: white;
      }
      &__reset {
        border-top: 1px solid #d3d8df;
        color: black;
      }

      &.active {
        margin-top: 0;
        top: 0%;
        left: 0%;

        /deep/ {
          .c-input-container-calendar {
            margin: 0 auto;

            .day {
              border-radius: 17px;
            }

            .day,
            .day-header {
              height: 34px !important;
            }
          }
        }
      }
    }
  }

  .is-invalid &,
  &.is-invalid {
    .c-input-border {
      background: $color-error;
    }
  }

  .sm {
    display: none;
  }

  @include onlyMobile {
    .sm {
      display: block;
    }
    .lg {
      display: none;
    }
    .c-input {
      &-container {
        &__actions {
          padding: 20px;
        }
      }
    }
  }
}
</style>
